export const SALESFORCE_DOMAIN_KEY = 'salesforce_domain';
export const TASK_AUTOMATIC_ERROR_BANNER_KEY = 'task_automation_error_banner';
export const NO_SALES_NAV_CHECK_FROM_USER = 'no_sales_nav_license';
export const MY_TEMPLATES = 'crono_my_templates';
export const OKTA_EMAIL_KEY = 'okta-email';
